import { Outlet, useParams } from "react-router";

export function CustomersHandler(props){
    
    let param = useParams();
    return <Outlet {...props} params={param} />
}